import strings from '../../../../locale/en'

export const determineTestStatus = (status: string): string => {
  if (status === 'PENDING') {
    return strings.test.pending
  } else if (status === 'STARTED') {
    return strings.test.unblock
  } else if (status === 'UNATTEMPTED' || status === 'APPROVED') {
    return strings.test.takeTest
  }
  return strings.test.takeTest
}

export const canTakeTest = (status: string): boolean =>
  status === 'UNATTEMPTED' || status === 'APPROVED'
